/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payments_Empty_State_CtaInputs */

const fr_payments_empty_state_cta = /** @type {(inputs: Payments_Empty_State_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir mes abonnements`)
};

/**

* @param {Payments_Empty_State_CtaInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payments_empty_state_cta = /** @type {((inputs?: Payments_Empty_State_CtaInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payments_Empty_State_CtaInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payments_empty_state_cta(inputs)
});